import { render, staticRenderFns } from "./wode.vue?vue&type=template&id=4ecb80b2"
import script from "./wode.vue?vue&type=script&lang=js"
export * from "./wode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports